import axios from "axios";

const Agent = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
  const tenant = window.location.hostname.split(".")[0]; // "fade"

  const responseBody = (response) => response.data;
  const responsePostBody = (response) => {
    return response;
  };

  const errorBody = (error) => error.response;
  const requests = {
    getFile: (url, attribute, token) =>
      axios
        .get(url, {
          params: attribute,
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
          responseType: "blob",
        })
        .then(responsePostBody),
    getAtt: (url, attribute, token) =>
      axios
        .get(url, {
          params: attribute,
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Tenant-Subdomain": tenant,
          },
        })
        .then(responseBody),
    get: (url, token, shopId) =>
      axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
            "X-Tenant-Subdomain": tenant,
          },
        })
        .then(responseBody),
    publicPost: (url, body, barbershopName) =>
      axios
        .post(url, body, {
          headers: {
            "Content-type": "application/json",
            "X-App-Platform": "Customer", // or "Customer", "Admin"
            Accept: "application/json",
            BarbershopName: barbershopName,
            "X-Tenant-Subdomain": tenant,
          },
          withCredentials: true,
        })
        .then(responseBody)
        .catch(errorBody),
    post: (url, body, token, shopId) =>
      axios
        .post(url, body, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responsePostBody)
        .catch(errorBody),
    put: (url, body, token, shopId) =>
      axios
        .put(url, body, {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
            "X-Tenant-Subdomain": tenant,
          },
        })
        .then(responsePostBody)
        .catch(errorBody),
    del: (url, token, shopId) =>
      axios
        .delete(url, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
            "X-Tenant-Subdomain": tenant,
          },
        })
        .then(responsePostBody)
        .catch(errorBody),
    postForm: (url, file, token) => {
      let formData = new FormData();
      formData.append("File", file);
      return axios
        .post(url, file, {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
        })
        .then(responsePostBody)
        .catch(errorBody);
    },
  };
  return {
    requests,
  };
};
export default Agent;
